export const mockData = {
  dealership: {
    name: "Autohaus Wilke",
    tagline: "Ihr Partner für Nissan, Mazda, Omoda & Jaecoo in Magdeburg",
    description: "Seit 1988 sind wir Ihr vertrauenswürdiger Partner für hochwertige Fahrzeuge der Marken Nissan und Mazda – neu im Programm: Omoda & Jaecoo. Mit unserem erfahrenen Team bieten wir Ihnen erstklassigen Service von der Beratung über den Verkauf bis hin zur Werkstatt.",
    contact: {
      phone: "+49 391 123456",
      email: "info@autohaus-wilke.de",
      address: {
        street: "Beispielstraße 123",
        city: "39104 Magdeburg",
        country: "Deutschland"
      }
    },
    openingHours: {
      verkauf: [
        { days: "Montag - Freitag", hours: "09:00 - 18:00 Uhr" },
        { days: "Samstag", hours: "09:00 - 13:00 Uhr" },
        { days: "Sonntag", hours: "Geschlossen" }
      ],
      werkstatt: [
        { days: "Montag - Freitag", hours: "07:30 - 17:00 Uhr" },
        { days: "Samstag", hours: "09:00 - 12:00 Uhr" },
        { days: "Sonntag", hours: "Geschlossen" }
      ]
    }
  },
  locations: [
    {
      id: 1,
      name: "Mazda",
      brand: "Mazda",
      url: "https://www.mazda-autohaus-wilke-magdeburg.de/",
      logo: "/mazda-logo-2024.svg",
      color: "#000000",
      image: "/brand-images/mazda-cx60-2026.jpg",
      address: {
        street: "Carnotstr. 3",
        zip: "39120",
        city: "Magdeburg"
      },
      phone: "0391 - 6357 7131",
      whatsapp: "+4939163577134",
      whatsappDisplay: "+49 391 6357 7134",
      email: "info@autohaus-wilke.de",
      mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2429.123!2d11.6275!3d52.1205!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47af5f5e8b5b8b8b%3A0x1234567890abcdef!2sCarnotstra%C3%9Fe%203%2C%2039120%20Magdeburg!5e0!3m2!1sde!2sde!4v1234567890"
    },
    {
      id: 2,
      name: "Nissan",
      brand: "Nissan",
      url: "https://wilke.haendler-nissan.de/",
      logo: "/nissan-logo-2020.svg",
      color: "#C3002F",
      image: "/brand-images/nissan-juke-2026.png",
      address: {
        street: "Silberbergweg 30",
        zip: "39128",
        city: "Magdeburg"
      },
      phone: "0391 - 6357 7137",
      whatsapp: "+4939163577134",
      whatsappDisplay: "+49 391 6357 7134",
      email: "info@autohaus-wilke.de",
      additionalBrandsNote: "Zusätzlich: Omoda & Jaecoo (bis 29.08.2026)",
      mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2430.456!2d11.6889!3d52.1678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47af5f5e8b5b8b8b%3A0x1234567890abcdef!2sSilberbergweg%2030%2C%2039128%20Magdeburg!5e0!3m2!1sde!2sde!4v1234567890"
    },
    {
      id: 3,
      name: "Mazda",
      brand: "Mazda",
      url: "https://www.mazda-autohaus-wilke-magdeburg.de/",
      logo: "/mazda-logo-2024.svg",
      color: "#000000",
      image: "/brand-images/mazda-cx5-2026.jpg",
      address: {
        street: "Körbelitzer Str. 10",
        zip: "39126",
        city: "Magdeburg"
      },
      phone: "0391 - 6357 7330",
      whatsapp: "+4939163577134",
      whatsappDisplay: "+49 391 6357 7134",
      email: "info@autohaus-wilke.de",
      mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2431.789!2d11.5678!3d52.0987!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47af5f5e8b5b8b8b%3A0x1234567890abcdef!2sK%C3%B6rbelitzer%20Stra%C3%9Fe%2010%2C%2039126%20Magdeburg!5e0!3m2!1sde!2sde!4v1234567890"
    },
    {
      id: 4,
      name: "Omoda & Jaecoo",
      brand: "Omoda & Jaecoo",
      url: "https://oj.autohaus-wilke.de",
      logo: "/omoda-jaecoo-logo.webp",
      color: "#0f172a",
      image: "/brand-images/jaecoo-7.jpg",
      address: {
        street: "Olvenstedter Graseweg 37",
        zip: "39128",
        city: "Magdeburg"
      },
      phone: "0391 - 6357 7137",
      whatsapp: "+4939163577134",
      whatsappDisplay: "+49 391 6357 7134",
      email: "info@autohaus-wilke.de",
      comingSoon: true,
      comingSoonNote: "Eröffnungsevent am Fr., 29.08.2026 im Florapark Magdeburg",
      mapUrl: "https://maps.google.com/maps?q=Olvenstedter%20Graseweg%2037%2C%2039128%20Magdeburg&t=&z=15&ie=UTF8&iwloc=&output=embed"
    }
  ],
  services: [
    {
      id: 1,
      title: "Fahrzeugverkauf",
      description: "Neuwagen und geprüfte Gebrauchtwagen von Nissan, Mazda, Omoda und Jaecoo"
    },
    {
      id: 2,
      title: "Werkstatt-Service",
      description: "Professionelle Wartung und Reparatur durch zertifizierte Techniker"
    },
    {
      id: 3,
      title: "Finanzierung",
      description: "Individuelle Finanzierungslösungen für Ihren Traumwagen"
    },
    {
      id: 4,
      title: "Probefahrt",
      description: "Testen Sie Ihr Wunschfahrzeug ausgiebig vor dem Kauf"
    }
  ],
  gallery: [
    {
      id: 1,
      url: "https://images.unsplash.com/photo-1574023278969-abb7ab49945c",
      alt: "Modern dealership showroom"
    },
    {
      id: 2,
      url: "https://images.unsplash.com/photo-1561259944-6bddd4623fc8",
      alt: "Luxury vehicle display"
    },
    {
      id: 3,
      url: "https://images.unsplash.com/photo-1615563868638-98253a7dc33b",
      alt: "Premium car showcase"
    }
  ]
};
